import { createRouter as createRouterLib, createWebHistory } from "vue-router";
import { setupLayouts } from "virtual:generated-layouts";
import { routes } from "vue-router/auto-routes";
import { useAuthStore } from "./stores/authStore";

export function createRouter() {
  const router = createRouterLib({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: setupLayouts(routes),
  });

  // Helper functions to check route meta
  const isPublicPath = (to) => {
    for (let i = to.matched.length - 1; i >= 0; i--) {
      if (to.matched[i].meta.public !== undefined) {
        return to.matched[i].meta.public;
      }
    }
    return false;
  };

  // Navigation guards
  router.beforeEach(async (to) => {
    const authStore = useAuthStore();
    const me = await authStore.authenticate();

    if (isPublicPath(to)) {
      return;
    } else if (me) {
      return;
    } else {
      return { path: "/login", query: { redirect: to.fullPath } };
    }
  });

  return router;
}
